<canvas #glCanvas class="grain-pulse__canvas"></canvas>
